module.exports = __webpack_public_path__ + "media/images/icons/outlined/minus-square-ba89c11637384cad8a513d4f5a359bd2.svg";